(async () => {
    const { debounce, parseHTML } = await import(window.theme.modules.utils);
    const baseComponent = await import(window.theme.modules.baseComponent);
    customElements.define('predictive-search-input', class extends baseComponent.default {
        elements = {
            input: 'input[name="q"]',
            results: '[data-results]'
        }

        minChars = 3;
        
        render() {
            this.sources = this.getAttribute('sources').split(',').filter(Boolean);
            this.$input.setAttribute('autocomplete', 'off');
            this.$input.focus();
            this.$input.addEventListener('input', debounce(this._inputHandler.bind(this), 300).bind(this));
        }

        _inputHandler(e) {
            this.searchQuery = this.$input.value.trim();

            this.searchQuery.length >= this.minChars
                ? this._getSearchResults()
                : this._cleanResults();
        }   

        _getSearchResults() {
            const query   = `q=${window.encodeURIComponent(this.searchQuery)}`;
            const type    = `${window.encodeURIComponent('resources[type]')}=${this.sources.join(',')}`;
            const available = `${window.encodeURIComponent('resources[options][unavailable_products]')}=${this.hasAttribute('only-stock-products') ? 'hide' : 'last'}`;
            const limit   = `${window.encodeURIComponent('resources[limit]')}=${this.getAttribute('results-limit')}`;
            // GEARS custom (restored Wave 13, 2026-08-21): ask the predictive-search API for variant SKUs.
            // Shopify does NOT search SKU by default on /search/suggest; without this the dropdown
            // returns nothing for a SKU even though the /search results page finds it. Lost in the
            // Galleria 3.3.4 -> 4.1.0 port on 2026-06-15 when the vendor rewrote this file.
            // 🔴 MUST be `resources[options][fields]`, NOT the 3.3.4 original's `resources[fields]`.
            // Measured 2026-08-21: as soon as ANY resources[options][...] param is present (4.1.0
            // added resources[options][unavailable_products] on the line above), Shopify IGNORES the
            // legacy top-level resources[fields] and returns 'No results found'. A verbatim restore
            // of the 3.3.4 line looks correct in the request URL and silently does nothing.
            const fields  = `${window.encodeURIComponent('resources[options][fields]')}=title,product_type,variants.title,vendor,variants.sku`;
            const section = 'section_id=predictive-search';

            fetch(`${window.theme.routes.predictiveSearch}?${[query, type, fields, limit, available, section].join('&')}`)
                .then(res => {
                    if(res.ok) {
                        return res.text();
                    }
                })
                .then(text => {
                    const resultsMarkup = parseHTML(text).querySelector('#shopify-section-predictive-search');
                    if (resultsMarkup) {
                        this.$results.replaceChildren(resultsMarkup);
                    } else {
                        this._cleanResults();
                    }
                })
        }
        _cleanResults() {
            this.$results.replaceChildren();
        }
    });
})()